import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    defaultMessage: 'You must accept terms and conditions',
  },
});
